import React, { useMemo } from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import { cn } from '@/lib/utils';

const WhoBenefits = ({
  data,
}: {
  data?: {
    title?: string;
    desc?: string;
    cards?: {
      title?: string;
      desc?: string;
      imgPath?: string;
    }[];
  };
}) => {
  // const section4 = contentData?.contentInfo?.['section-4'];

  const getContent = useMemo(() => {
    if (!data) return null;
    return (
      <div className={styles.content}>
        {data?.title && <h2 className={cn(styles.title, { 'mb-[3.125rem]': !data?.desc })}>{data?.title}</h2>}
        {data?.desc && <p className="mt-8 mb-[3.125rem] text-[1.125rem] leading-6 text-center">{data?.desc}</p>}
        <div className={styles.featuresGrid}>
          {data?.cards?.map?.((item, index) => (
            <div className={styles.featureItem} key={index}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '12px' }}>
                <Image src={item.imgPath} alt={''} width={48} height={48} />
                <h3 style={{ fontSize: '20px', fontWeight: 600 }}>{item.title}</h3>
              </div>
              <p style={{ fontSize: '16px', color: '#666' }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    );
  }, [data]);

  return getContent;
};

export default WhoBenefits;
